'use client';

import React from 'react';
import DOMPurify from 'dompurify';
import FormatValue from '@/utils/FormatValue';

interface InfoWindowData {
  title: string;
  address: string;
  phone: string;
  email: string;
  description: string;
}

export const InfoWindowContent: React.FC<{ data: Partial<InfoWindowData> }> = ({
  data: { title, address, phone, email, description },
}) => {
  const sanitizedDescription = description
    ? DOMPurify.sanitize(description)
    : '';

  return title && address ? (
    <div className='px-3 pb-5 text-left'>
      <div className='flex flex-col gap-4 text-left text-xs tracking-wide sm:text-sm'>
        <h1 className='font-bold'>{title}</h1>
        <div>{address}</div>
        <div className='text-sm text-primary'>
          {phone && (
            <div className='flex items-center gap-1'>
              <span>Phone :</span>
              <a href={`tel:${phone}`}>
                {FormatValue.phoneNumber(parseInt(phone))}
              </a>
            </div>
          )}
          {email && (
            <div className='flex items-center gap-1'>
              <span>Email :</span>
              <a href={`mailto:${email}`}>{email}</a>
            </div>
          )}
          {description && (
            <div
              dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
              className='flex items-center gap-1'
            />
          )}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
